import { Product, ProductVariant } from 'shopify-types'

import type { ProductFieldsFragment, ProductVariantFieldsFragment } from '../__generated/storefront'
import { mapGQLMoneyToMoney } from '../graphql'

export type GQLProductVariant = ProductVariantFieldsFragment

export const mapGQLProductVariantToProductVariant = (
  variant: GQLProductVariant,
): ProductVariant => ({
  ...variant,
  sku: variant.sku ?? '',
  price: mapGQLMoneyToMoney(variant.price),
  unitPrice: mapGQLMoneyToMoney(variant.unitPrice ?? undefined) as ProductVariant['unitPrice'],
  compareAtPrice: mapGQLMoneyToMoney(variant.compareAtPrice ?? undefined),
  image: {
    id: variant.image?.id ?? '',
    src: variant.image?.src ?? '',
    altText: variant.image?.altText ?? undefined,
    width: variant.image?.width ?? 0,
    height: variant.image?.height ?? 0,
  },
  unitPriceMeasurement: {
    referenceValue: variant.unitPriceMeasurement?.referenceValue ?? 0,
    referenceUnit: variant.unitPriceMeasurement?.referenceUnit ?? '',
  },
  hidden: variant.hidden?.value === 'true',
})

export type GQLProduct = ProductFieldsFragment

export const mapGQLProductToProduct = (product: GQLProduct): Product => ({
  ...product,
  options: product.options.map(option => ({
    id: option.id,
    name: option.name,
    values: option.optionValues.map(value => value.name),
  })),
  totalInventory: product.totalInventory ?? 0,
  images: product.images.edges.map(edge => ({
    id: edge.node.id ?? '',
    src: edge.node.src,
    altText: edge.node.altText ?? '',
    width: edge.node.width ?? 0,
    height: edge.node.height ?? 0,
  })),
  variants: product.variants.edges.map(edge => mapGQLProductVariantToProductVariant(edge.node)),
})
